export default __webpack_public_path__ + "static/media/eye.c8b83656.svg";